import { Component, Input } from '@angular/core';

import { MonitoringResults } from '@classes/monitoring/monitoring-results';

@Component({
  selector: 'app-monitoring-results-print',
  templateUrl: './monitoring-results-print.component.html',
  styleUrls: ['./monitoring-results-print.component.scss']
})
export class MonitoringResultsPrintComponent {

    @Input() results: MonitoringResults;

    constructor () {}

}
